import type { ListCampaignRow } from 'modules/campaign/row';
import { SupplierTitle } from 'modules/supplier/supplier/components';
import { periodColumn } from 'components/columns';
import { BlockWidget, BoundStates, ClientTitle, Period } from 'components';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { sepFormat } from 'utilities';
import { Box, Icon } from '@ff-it/ui';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { PlanRowKindIcon } from 'modules/campaign/plan/components/PlanRowIcons';
import { OverflowContainer } from 'components/OverflowContainer/OverflowContainer';

const sumProps = {
  width: 115,
  cellProps: {
    textAlign: 'end' as const,
  },
};

export const columns: ControlledTableColumns<ListCampaignRow> = [
  flexColumn({
    content: 'Block',
    key: 'block.code',
    required: true,
    cellProps: { className: 'py-0' },
    render: ({ id, kind, block }: ListCampaignRow) => (
      <Box display="flex" alignItems="center" gap="1">
        <EnterpriseLink to={`/planning/campaigns/${block.campaign.id}/planning/${block.id}?rowId=${id}`}>
          <PlanRowKindIcon kind={kind} />
        </EnterpriseLink>
        <Box style={{ minWidth: 0 }}>
          <BlockWidget {...block} campaign_id={block.campaign.id} link target="_self" clamp />
        </Box>
      </Box>
    ),
    sortable: true,
  }),
  flexColumn({
    content: 'Client',
    key: 'block.client',
    cellProps: {
      className: 'py-1',
    },
    render: ({ block: { campaign } }) => <ClientTitle {...campaign} />,
  }),
  {
    content: 'Supplier',
    key: 'supplier',
    minWidth: 200,
    maxWidth: 0,
    cellProps: {
      className: 'py-1',
    },
    render: ({ supplier }) =>
      supplier ? (
        <OverflowContainer>
          <SupplierTitle {...supplier} />
        </OverflowContainer>
      ) : null,
  },
  {
    ...periodColumn,
    sortable: false,
    render: ({
      sums: {
        planned: { date_from, date_to },
      },
    }) => <Period date_from={date_from} date_to={date_to} />,
  },
  {
    ...sumProps,
    content: 'Client total',
    key: 'state.income_total',
    render: ({ state }) => sepFormat(!state.canceled ? state.income_total : null),
  },
  {
    ...sumProps,
    content: 'Provider total',
    key: 'state.expense_total',
    render: ({ state }) => sepFormat(!state.canceled ? state.expense_total : null),
  },

  {
    ...sumProps,
    content: 'Revenue',
    key: 'state.revenue',
    render: ({ state }) => sepFormat(!state.canceled ? state.revenue : null),
  },
  {
    width: 64,
    cellProps: {
      textAlign: 'center',
    },
    key: 'state',
    configLabel: 'Bound States',
    render: ({ id, state, passthrough }: ListCampaignRow) => {
      if (state.canceled) {
        return null;
      }
      if (passthrough) {
        return <Icon icon="link-simple-slash" />;
      }
      return <BoundStates {...state} row={id} />;
    },
  },
];
